import { Component, OnInit, OnChanges, SimpleChanges, Input, ChangeDetectionStrategy, AfterViewInit } from '@angular/core';
import Chart from 'chart.js';
@Component({
    selector: 'sb-chart-line',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './line-chart.component.html',
    styleUrls: ['./line-chart.component.css']
})
export class LineChartComponent implements OnInit, OnChanges, AfterViewInit {
    @Input() dataChart: { data: any[]; labelsHorizontal: string[] };
    @Input() chartInputId: any;
    chart!: Chart;
    chartId: string = '1';
    constructor() {}

    ngOnInit(): void {
        this.chartId = this.chartInputId;
        console.log(this.chartId);
    }
    ngOnChanges(changes: SimpleChanges): void {
        if (changes.dataChart.currentValue) {
            if (this.chart) {
                this.chart.destroy();
                this.chart = null;
            }
            this.createChart();
        }
    }
    ngAfterViewInit() {
        this.createChart();
    }
    numberWithCommas(x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
    createChart() {
        this.chart = new Chart(this.chartId, {
            type: 'line',
            data: {
                labels: this.dataChart?.labelsHorizontal,
                datasets: this.dataChart?.data
            },
            options: {
                aspectRatio: 2.5,
                tooltips: {
                    callbacks: {
                        label: function (tooltipItem, data) {
                            return tooltipItem.xLabel + ': ' + tooltipItem.yLabel.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                        }
                    }
                },
                scales: {
                    yAxes: [
                        {
                            ticks: {
                                callback: function (label, index, labels) {
                                    return label.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                                },
                                beginAtZero: true,
                                fontSize: 10
                            }
                        }
                    ]
                },
                responsive: true,
                maintainAspectRatio: false
            }
        });
    }
}
